module.exports = __webpack_public_path__ + "static/media/dice_5.0ac0efd3.svg";